import { Button } from 'flowbite-react';
import React from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { useUserContext } from 'src/context/UserProvider';

interface Props {
	companyName?: string;
	handleCreatePosition: () => void;
	disableCreate: boolean;
	title?: string;
	buttonText?: string;
}

const PositionsTopBar = ({ handleCreatePosition, disableCreate, companyName, title, buttonText }: Props) => {
	const { isRecruiterLoggedIn } = useUserContext();
	return (
		<>
			<div className="flex justify-between items-center py-2 pt-6 sm:pt-[10px] border-b border-[#EBEBF0] dark:border-[#555770] border-solid">
				<div className="text-lg font-semibold dark:text-white">
					{isRecruiterLoggedIn ? title || 'My Job Postings' : title || `Positions in ${companyName}`}
				</div>
				<div>
					<Button
						className="whitespace-pre"
						disabled={disableCreate}
						onClick={handleCreatePosition}
						color="purplePlaced"
					>
						<AiOutlinePlus className="mr-2" />
						{buttonText || 'Post a job'}
					</Button>
				</div>
			</div>
		</>
	);
};

export default PositionsTopBar;
